import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCartItems, setMyCartModalVisibility } from "../../store/actions";

export default function EssentialProductsSection({ products }) {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cartItems);
  const myCartModalVisibility = useSelector((state) => state.myCartModalVisibility);

  const handleAddToCart = (e, item) => {
    e.preventDefault();
    const product = cartItems.find((x) => x.product_id === item.product_id);
    if (!product) {
      item.product_quantity = 1;
      dispatch(setCartItems([...cartItems, item]));
      dispatch(setMyCartModalVisibility(!myCartModalVisibility));
    } else {
      dispatch(setCartItems(cartItems.filter((x) => x.product_id !== item.product_id)));
    }
  };

  const handlePreview = (e, item) => {
    e.preventDefault();
    // Instead of changing the element type, simply perform your preview logic.
    // For example, redirect to the product page or open a modal.
    window.location.href = `/product/${item.product_slug}`;
  };

  return (
    <section className="pb-11 pb-lg-15">
      <div className="container">
        <h2 className="mb-8 text-center fs-30 fs-md-40">Essenzielle Artikel</h2>
        <div className="row mb-6">
          {products.slice(0, 4).map((item, index) => {
            const file_url = `/media/${item.product_slug}${item.cover_image}`;
            const product_image_url = `url('${file_url}')`;
            // Price calculations as before
            const originalPrice = Number(item.product_price);
            const discount = Number(item.product_discount);
            const priceWithDiscount =
              discount > 0
                ? (originalPrice - (discount * originalPrice) / 100).toFixed(2)
                : originalPrice.toFixed(2);

            return (
              <div key={index} className="col-sm-6 col-lg-3 mb-6" data-animate="fadeInUp">
                <div className="card border-0 hover-change-content product">
                  <div className="card-img-top position-relative">
                    <div
                      style={{ backgroundImage: product_image_url }}
                      className="card-img ratio bg-img-cover-center ratio-1-1"
                    />
                    <div className="position-absolute pos-fixed-bottom px-4 px-sm-6 pb-5 d-flex w-100 justify-content-center content-change-horizontal">
                      <a
                        href="#"
                        data-toggle="tooltip"
                        title="Add to cart"
                        className="add-to-cart d-flex align-items-center justify-content-center text-primary bg-white hover-white bg-hover-primary w-45px h-45px rounded-circle mr-2 border"
                        onClick={(e) => handleAddToCart(e, item)}
                      >
                        <i className="far fa-shopping-basket"></i>
                      </a>
                      <a
                        href="#"
                        data-toggle="tooltip"
                        title="Preview"
                        className="preview d-flex align-items-center justify-content-center text-primary bg-white hover-white bg-hover-primary w-45px h-45px rounded-circle border"
                        onClick={(e) => handlePreview(e, item)}
                      >
                        <i className="far fa-eye"></i>
                      </a>
                    </div>
                  </div>
                  <div className="card-body px-0 pt-4 pb-0 d-flex align-items-end">
                    <div className="mr-auto">
                      <a
                        href="#"
                        className="text-uppercase text-muted letter-spacing-05 fs-12 d-block font-weight-500"
                      >
                        {item.category || ""}
                      </a>
                      <a href={`/product/${item.product_slug}`} className="font-weight-bold mt-1 d-block">
                        {item.product_name || ""}
                      </a>
                    </div>
                    <div className="d-flex align-items-center">
                      {discount > 0 && (
                        <span className="text-line-through text-white fs-14 d-inline-block mr-2 font-weight-normal">
                          {originalPrice.toFixed(2)} EUR
                        </span>
                      )}
                      <p className="text-primary mb-0 font-weight-500">
                        {priceWithDiscount} EUR
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="text-center">
          <a
            href="/shop"
            className="btn btn-outline-primary text-uppercase letter-spacing-05"
          >
            Jetzt zugreifen
          </a>
        </div>
      </div>
    </section>
  );
}